import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const townNCountryConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Town \'n\' Country Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Town \'n\' Country, FL. Sam\'s Tree Service handles dangerous trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_town_n_country',

   /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: "Serving Town 'n' Country",
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: "Professional Tree Service in Town 'n' Country Specializing In Dangerous Trees",

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we handle the tree work that keeps 
     homes and properties safe throughout <strong>Town 'n' Country</strong>. 
     This busy West Tampa community has a dense mix of residential neighborhoods, 
     commercial areas, and established trees that grow close to structures, 
     driveways, and power lines. When storm season arrives, overgrown or 
     weakened trees create real hazards fast and our team responds quickly 
     and professionally.`,

    `We specialize in <strong>dangerous tree removal and targeted trimming</strong> 
     large overhanging limbs near homes and carports, storm split trunks, 
     trees crowding utility lines, and heavy canopy overgrowth that increases 
     wind load risk across the property. We work on tight residential lots 
     every day and do the job right.`,

    `<strong>Sam's Tree Service</strong> provides trusted, affordable tree care 
     throughout <strong>Town 'n' Country</strong> and the surrounding 
     <strong>West Hillsborough</strong> area protecting your property and 
     keeping your trees safe and healthy all year long.`,
  ],
  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: "Town 'n' Country, FL",
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_TownNCountry = () => <LocationPage config={townNCountryConfig} />;
export default Services_TownNCountry;
